const cleanStatus = (status) => status.replace(/_DEBTOR|_CLIENT$/, '');

const buildRestrictionMessage = (label, id, isAccepted = true) => ({
  id,
  restriction: id,
  restrictionLabel: label,
  status: isAccepted ? 'ACCEPTED' : 'CREATED',
  statusLabel: isAccepted ? 'Aprobado' : 'Pendiente',
});

export const isWithoutRatification = (status, isRatified) => (
  status?.includes('WITHOUT_RESTRICTION') || status?.includes('WHITHOUT_RATIFICATION') || isRatified
);

export const getWithoutRatificationTranslation = (evaluationResolution) => {
  const result = [];
  if (evaluationResolution.reviewOc) {
    result.push(buildRestrictionMessage('Enviar orden de compra de factura', 'review_oc'));
  }
  if (evaluationResolution.reviewHes) {
    result.push(buildRestrictionMessage('Enviar HES de factura', 'review_hes'));
  }
  if (evaluationResolution.reviewPortalScreenshot) {
    result.push(buildRestrictionMessage('Enviar captura de pantalla del portal de proveedor', 'review_portal_screenshot'));
  }
  if (evaluationResolution.hasReceptionAcknowledgment) {
    result.push(buildRestrictionMessage('Contar con acuse de recibo', 'reception_acknowledgment'));
  }
  return result;
};

export default function getRatificationStatusTranslation(status, isRatified = false) {
  if (!status) return null;
  const statusWithoutSuffix = cleanStatus(status);
  switch (statusWithoutSuffix) {
    case 'WITH_RATIFICATION':
      return buildRestrictionMessage('Esperar validación de factura por parte del receptor', 'ratification', isRatified);
    case 'WITH_RATIF_OR_RECEPT_ACK':
      return buildRestrictionMessage('Esperar validación de factura por parte del receptor o acuse de recibo', 'ratification_or_receipt_ack', isRatified);
    case 'WHITHOUT_RATIFICATION':
      return null;
    default:
      return null;
  }
}

export const shouldShowRatificationMessage = (invoice, ratificationRestriction) => (
  ratificationRestriction
  && !isWithoutRatification(invoice?.offer?.transferCondition, invoice?.isRatificated)
);

export const transferConditionsIconColor = (offer, restrictions = [], invoiceDocuments = []) => {
  const safeRestrictions = Array.isArray(restrictions) ? restrictions : [];
  const safeInvoiceDocuments = Array.isArray(invoiceDocuments) ? invoiceDocuments : [];

  if (offer == null) {
    return 'gray.A400';
  }
  if (!safeRestrictions.length) {
    return 'success.main';
  }
  const requiredDocuments = safeRestrictions.reduce((acc, restriction) => {
    if (restriction.documentInfo != null) {
      acc.push(restriction.documentInfo);
    }
    return acc;
  }, []);
  const allDocumentsUploaded = requiredDocuments.every(
    (requiredDocument) => safeInvoiceDocuments.some(
      (invoiceDocument) => invoiceDocument.type.code === requiredDocument.documentType,
    ),
  );
  if (allDocumentsUploaded) {
    return 'warning.main';
  }
  return 'error.A600';
};
